module.exports = __webpack_public_path__ + "assets/img/binzhu2.917c0094.jpg";